<fieldset class="client-intake-fieldset-control">
  <legend class="label" [ngClass]="{ hidden: showLabel === false }">
    <span>{{ label }}</span>
    @if (isOptional){
    <span class="optional-label">(Optional)</span>
    } @if (helperText){
    <div class="helper-text">
      {{ helperText }}
    </div>
    }
  </legend>
  <ng-content></ng-content>

  @if (detailsTitle && detailsMessage){
  <d3-details [title]="detailsTitle" [marginTop]="detailsMarginTop">
    <div [innerHTML]="detailsMessage"></div>
  </d3-details>
  } @if (helperMessage){
  <div class="helper-text">
    {{ helperMessage }}
  </div>
  }
</fieldset>
